<template>
    <div class="animated fadeIn vld-parent">
        <b-row>
            <b-col>
                <div style="background: rgb(251, 251, 251); padding: 5px 32px 4px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <b-col md="2">
                            <b-form-input v-model="newUser" placeholder="Neuen Kontrolleur anlegen"></b-form-input>
                        </b-col>
                        <b-col xl="1" lg="3" md="4" sm="4">
                            <b-button :disabled="disabled" variant="primary" class="px-4" v-on:click="addUser">Hinzufügen</b-button>
                        </b-col>
                        <b-col xl="2" lg="4" md="4" sm="4">
                            <b-button variant="primary" class="px-4" v-on:click="addDevice">Gerät anmelden</b-button>
                        </b-col>
                        <b-col></b-col>
                        <b-col xl="2" lg="4" md="5" sm="5">
                            <b-button style="float: right" variant="primary" class="px-4" v-on:click="importUser">Mitarbeiter importieren</b-button>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row style="padding-top: 45px; padding-left: 30px; padding-right: 30px">
            <b-col>
                <b-table striped hover :items="items"
                         :fields="fields">
                </b-table>
            </b-col>
        </b-row>
        <b-modal
                id="init-modal"
                centered
                title="Verschlüsselungs Passwort setzen"
                cancel-title="Abbrechen"
                ok-title="Speichern"
                @ok="onOk"
                @hide="resetModal"
                ok-variant="info"
                ok-only
        >
            <b-row style="padding: 18px">
                <b-col>
                    <p style="margin-bottom: 0.5rem">Im folgenden setzten Sie ihr Verschlüsselungspasswort, dieses wird für alle mitabeiterbezogenen Daten verwendet.
                        Es wird benötigt um Namen wieder kenntlich zu machen. Fall Sie dieses Passwort verlieren ist es nicht mehr möglich Namen zu entschlüsseln.</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Passwort:</p>
                    <b-form-input v-on:focus="pwdError=''" v-model="pwd" placeholder="Passwort" type="password"></b-form-input>
                    <p style="margin-bottom: 0.5rem; margin-top: 1rem">Passwort wiederholen:</p>
                    <b-form-input v-on:focus="pwdError=''" v-model="pwdRepeat" placeholder="Passwort" type="password"></b-form-input>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
            <b-row v-if="pwdError !== ''"><p style="margin-top: 2rem; margin-left: 1rem; color: red;">{{pwdError}}</p></b-row>
        </b-modal>
        <b-modal
                id="pwd-modal"
                centered
                title="Mitarbeiter entschlüsseln"
                cancel-title="Abbrechen"
                ok-title="OK"
                @ok="onLogin"
                ok-variant="info"
                ok-only
        >
            <b-row style="padding: 18px">
                <b-col>
                    <p style="margin-bottom: 0.5rem">Bitte geben Sie Ihr Verschlüsselungs Passwort ein um fortzufahren.</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem">Passwort:</p>
                    <b-form-input v-model="pwd" placeholder="Passwort" type="password"></b-form-input>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
            <b-row v-if="pwdError !== ''"><p style="margin-top: 2rem; margin-left: 1rem; color: red;">{{pwdError}}</p></b-row>
        </b-modal>
        <b-modal
                id="tan-modal"
                centered
                title="Bisoffice Verknüpfung"
                ok-title="OK"
                ok-variant="info"
                ok-only
        >
            <b-row style="padding: 18px">
                <b-col>
                    <p style="margin-bottom: 0.5rem">Eine Verbindungsanfrage wurde an Ihre Bisoffice Software versendet. Bitte nehmen Sie das Gerät mit der folgenden Tan an und klicken Sie anschliessend erneut auf "Mitarbeiter importieren".</p>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3"></b-col>
                <b-col>
                    <p style="margin-bottom: 0.5rem; text-align: center; font-size: 18px"><b>Tan: {{tan}}</b></p>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-modal>
        <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null">
        </CoolLightBox>
    </div>

</template>

<script>
    import {Server_URL} from "../../shared/utils";
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        name: "controler",
        components: {
            CoolLightBox,
        },
        mounted() {
            this.showLoader();
            this.$http.get(
                Server_URL+'/baumkontrolle/controller_settings'
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                loader: undefined,
                fields: [
                    {key: "wert", label: "Name"},
                    {key: "typ", label: "Bauhofmitarbeiter", formatter: this.formateTyp},
                    {key: "cd1", label: "Mitarbeitergruppe"},
                    {key: "cd2", label: "Kostenstelle"},
                    {key: "schluessel", label: "Mitarbeiterschluessel"},
                ],
                items: [],
                uninitialised: false,
                newUser: "",
                pwd: "",
                pwdRepeat: "",
                finished: false,
                disabled: true,
                pwdError: "",
                decryptKey: "",
                tan: "",
                images: [Server_URL+"/baumkontrolle/qr"],
                index: null,
            }
        },
        methods: {
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },

            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    this.$bvToast.toast(`Das Passwort war nicht korrekt.`, {
                        title: 'Falsches Passwort',
                        autoHideDelay: 5000,
                        appendToast: false,
                        toaster: 'b-toaster-top-center',
                    })
                } else {
                    console.log(response);
                }
            },
            responseImport(response) {
                this.hideLoader();
                if (response.status === 401) {
                    this.$bvToast.toast(`Das Passwort war nicht korrekt.`, {
                        title: 'Falsches Passwort',
                        autoHideDelay: 5000,
                        appendToast: false,
                        toaster: 'b-toaster-top-center',
                    })
                } else {
                    console.log(response);
                    this.$bvToast.toast(`Die Baumkontrolle konnte mit keiner Bisoffice Suite verbunden werden.`, {
                        title: 'Achtung',
                        autoHideDelay: 5000,
                        appendToast: false,
                        toaster: 'b-toaster-top-center',
                    })
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.uninitialised = !response.data.init;
                    if (this.uninitialised) {
                        this.$bvModal.show("init-modal");
                    } else {
                        this.$bvModal.show("pwd-modal");
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkSetPwd(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.disabled = false;
                    this.uninitialised = false;
                } else {
                    console.log(response);
                }
            },
            responseOkImport(response) {
                this.hideLoader();
                if (response.status === 200) {
                    if (response.data.tan !== undefined) {
                        this.tan = response.data.tan;
                        this.$bvModal.show("tan-modal");
                    } else {
                        this.fetchUser()
                    }
                } else {
                    console.log(response);
                }
            },
            responseLogin(response) {
                if (response.status === 200) {
                    this.pwd = "";
                    this.pwdRepeat = "";
                    this.newUser = "";
                    this.disabled = false;
                    this.uninitialised = false;
                    this.fetchUser();
                } else {
                    console.log(response);
                }
            },
            responseFetchUser(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.items = response.data;
                } else {
                    console.log(response);
                }
            },
            isBlank(str) {
                return (!str || /^\s*$/.test(str));
            },
            onOk(e) {
                if (this.isBlank(this.pwd) || this.isBlank(this.pwdRepeat)) {
                    this.pwdError = "Das Passwort darf nicht leer sein.";
                    e.preventDefault()
                } else if (this.pwd.trim() !== this.pwdRepeat.trim()) {
                    this.pwdError = "Die Passwörter stimmen nicht überein.";
                    e.preventDefault()
                } else {
                    this.pwdError = "";
                    this.decryptKey = this.pwd;
                    this.showLoader();
                    this.$http.post(
                        Server_URL+'/baumkontrolle/controller_pwd', {pwd: this.decryptKey}
                    ).then(this.responseOkSetPwd, this.responseError)
                }
            },
            onLogin(e) {
                if (this.isBlank(this.pwd)) {
                    this.pwdError = "Das Passwort darf nicht leer sein.";
                    e.preventDefault()
                } else {
                    this.pwdError = "";
                    this.decryptKey = this.pwd;
                    this.showLoader();
                    this.$http.post(
                        Server_URL+'/baumkontrolle/controller_pwd_check', {pwd: this.decryptKey}
                    ).then(this.responseLogin, this.responseError)
                }
            },
            addUser() {
               if (this.uninitialised) {
                   this.$bvModal.show("init-modal");
                   return;
               } else if(this.disabled) {
                   this.$bvModal.show("pwd-modal");
                   return;
               }
               if (this.isBlank(this.newUser)) {
                   this.$bvToast.toast(`Der Name des Kontoleurs darf nicht leer sein.`, {
                       title: 'Speichern nicht möglich',
                       autoHideDelay: 5000,
                       appendToast: false,
                       toaster: 'b-toaster-top-center',
                   });
                   return;
               }
                this.showLoader();
                this.$http.post(
                    Server_URL+'/baumkontrolle/controller/user_external', {pwd: this.decryptKey, name: this.newUser}
                ).then(this.responseLogin, this.responseError)
            },
            importUser() {
                if (this.uninitialised) {
                    this.$bvModal.show("init-modal");
                    return;
                } else if(this.disabled) {
                    this.$bvModal.show("pwd-modal");
                    return;
                }
                this.showLoader();
                this.$http.post(
                    Server_URL+'/baumkontrolle/controller/import', {pwd: this.decryptKey}
                ).then(this.responseOkImport, this.responseImport)
            },
            fetchUser() {
                this.showLoader();
                this.$http.post(
                    Server_URL+'/baumkontrolle/controller/users', {pwd: this.decryptKey}
                ).then(this.responseFetchUser, this.responseError)
            },
            resetModal() {
                this.pwd = "";
                this.pwdRepeat = "";
                this.pwdError = "";
            },
            formateTyp(value) {
                if (value === "mita") {
                    return "Ja";
                }  else {
                    return  "Nein";
                }
            },
            addDevice() {
                this.index = 0;
            }
        }
    }
</script>

<style scoped>

</style>
